import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
import { PDFDocument, StandardFonts, setFontAndSize } from 'pdf-lib';
//import fontkit from '@pdf-lib/fontkit';
import documentDefination from "./DocumentDefination";
import pdfFonts from "../../fonts/custom-fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  Interstate: {
    normal: "EYInterstate-Regular.ttf",
    bold: "EYInterstate-Regular.ttf",
    italics: "EYInterstate-Regular.ttf",
    bolditalics: "EYInterstate-Regular.ttf",
  },
};
const CHANGE_COLOR = "#87d3f2";
const BASELINE_COLOR = "#9c82d4";
const REMAINING_COLOR = "#ffb6c1";
const getColor = (type, data) => {
  const sectionData = data.assessmentSectionList.find(
    (list) => list.name === type
  );
  return sectionData ? sectionData.color : "#f9f9fb";
};
let emptyProfPic =
  "data:image/png;base64,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";

const focuspdfmakedownload = (fileName, data) => {
  // console.log(temp);  
  let temp = { ...documentDefination };
  temp.header.table.body[0][1].text = data.title;
  //update profile data dynamically
  temp.content[0].table.body[0][0].image = data.userImg
    ? data.userImg
    : emptyProfPic;
  temp.content[0].table.body[0][1].text =
    "Name: " + data.userProfileData.preferredName;
  temp.content[0].table.body[0][2].text =
    "Rank: " + data.userProfileData.rankDesc;
  temp.content[0].table.body[1][1].text =
    "Region: " + data.userProfileData.region;
  temp.content[0].table.body[1][2].text =
    "Lead Reviewer: " + data.userProfileData.counselorName;
  temp.content[0].table.body[2][1].text =
    "Office: " + data.userProfileData.locationCity;
  temp.content[0].table.body[2][2].text =
    "Country: " + data.userProfileData.country;

  //update summary data dynamically
  temp.content[1].table.body[1][0].text = data.summaryData;
  temp.content[1].table.body[2][0].text = "";
  /* PPMD SCORING HIDDEN */
  // temp.content[1].table.body[3][0].image = data.GraphImg;

  //GM wise
  let content = [...temp.content];
  data.summaryDataArray &&
    data.summaryDataArray.map((pillerObj, index) => {
      //..Check if focused statement selected
      let isFocused = false;
      if (pillerObj && pillerObj.tabList) {
        for (let index = 0; index < pillerObj.tabList.length; index++) {
          const element = pillerObj.tabList[index];
          if (element
            && element.focused
            && Array.isArray(element.focused)
            && element.focused.length > 0) {
            isFocused = true;
            break;
          }
        }
      }
      if (isFocused) {
        let tempGM = {
          //GMHeader
          margin: [0, 10, 0, 0],
          layout: "noBorders",
          //pageBreak: "before",
          table: {
            widths: ["*"],
            heights: [30],
            style: "summarySection",
            alignment: "center",
            body: [
              [
                {
                  style: "mainHeading",
                  text: pillerObj.pillarDisplayName,
                },
              ],
            ],
          },
        };
        content.push({ ...tempGM }); //GM heading
      }
      pillerObj.tabList &&
        pillerObj.tabList.map((goal, indexG) => {
          // if(goal.comitted&&goal.comitted.length>0){
          //   let GoalHeader={
          //     //GoalCommittedHeader
          //     layout: "noBorders",
          //     table: {
          //       dontBreakRows: true,
          //       widths: ["*"],
          //       heights: [30],
          //       style: "summarySection",
          //       alignment: "center",
          //       body: [
          //         [
          //           {
          //             style: "subHeading",
          //             text:` ${pillerObj.pillarDisplayName+"— "+goal.goal+" — Committed"}`,
          //           },
          //         ],
          //       ],
          //     },
          //   };
          //   content.push({...GoalHeader}); //GoalCommittedHeader

          // }
          goal.focused &&
            goal.focused.length > 0 &&
            goal.focused.map((comittedItem, indexC) => {
              if (indexC == 0) {
                let HeaderPlusStmnt = {
                  //Committed stmnt
                  fillColor: "white",
                  layout: "noBorders",
                  unbreakable: true,
                  table: {
                    dontBreakRows: true,
                    unbreakable: true,
                    widths: ["*"],
                    heights: ["auto"],
                    body: [
                      [
                        {
                          //GoalCommittedHeader
                          layout: "noBorders",
                          table: {
                            dontBreakRows: true,
                            widths: ["*"],
                            heights: [30],
                            style: "summarySection",
                            alignment: "center",
                            body: [
                              [
                                {
                                  style: "subHeading",
                                  text: ` ${pillerObj.pillarDisplayName +
                                    "— " +
                                    goal.goal +
                                    " — Focused"
                                    }`,
                                },
                              ],
                            ],
                          },
                        },
                      ],
                      [
                        {
                          //Committed stmnt
                          fillColor: "white",
                          layout: "noBorders",
                          table: {
                            dontBreakRows: true,
                            widths: ["*"],
                            heights: ["auto"],
                            body: [
                              [
                                [
                                  {
                                    fillColor: "grey",
                                    margin: [10, 5],
                                    layout: {
                                      hLineColor: function (i, node) {
                                        return "white";
                                      },
                                      vLineColor: function (i, node) {
                                        return i === 0
                                          ? getColor(
                                            comittedItem.qstn.type,
                                            data
                                          )
                                          : "white";
                                      },
                                      vLineWidth: function (i, node) {
                                        return i === 0 ? 3 : 0;
                                      },
                                      hLineWidth: function (i, node) {
                                        return i === 0 ||
                                          i === node.table.body.length
                                          ? 0
                                          : 0;
                                      },
                                    },
                                    table: {
                                      widths: ["*"],
                                      heights: ["auto"],
                                      alignment: "center",
                                      body: [
                                        [
                                          {
                                            style: "statment",
                                            text: [comittedItem.qstn.impactActions,
                                            { text: "\n" },
                                            { text: "\n" },
                                            { text: `\t\t- ${comittedItem.qstn.selectedOption}`, fontSize: 8, italics: true }],
                                          },
                                        ],
                                      ],
                                    },
                                  },
                                ],
                              ],
                            ],
                          },
                        },
                      ],
                    ],
                  },
                };
                content.push({ ...HeaderPlusStmnt });
              } else {
                let comittedStmnt = {
                  //Committed stmnt
                  fillColor: "white",
                  layout: "noBorders",
                  table: {
                    dontBreakRows: true,
                    widths: ["*"],
                    heights: ["auto"],
                    body: [
                      [
                        [
                          {
                            fillColor: "grey",
                            margin: [10, 5],
                            layout: {
                              hLineColor: function (i, node) {
                                return "white";
                              },
                              vLineColor: function (i, node) {
                                return i === 0
                                  ? getColor(comittedItem.qstn.type, data)
                                  : "white";
                              },
                              vLineWidth: function (i, node) {
                                return i === 0 ? 3 : 0;
                              },
                              hLineWidth: function (i, node) {
                                return i === 0 || i === node.table.body.length
                                  ? 0
                                  : 0;
                              },
                            },
                            table: {
                              widths: ["*"],
                              heights: ["auto"],
                              alignment: "center",
                              body: [
                                [
                                  {
                                    style: "statment",
                                    text: [comittedItem.qstn.impactActions,
                                    { text: "\n" },
                                    { text: "\n" },
                                    { text: `\t\t- ${comittedItem.qstn.selectedOption}`, fontSize: 8, italics: true }],
                                  },
                                ],
                              ],
                            },
                          },
                        ],
                      ],
                    ],
                  },
                };
                content.push({ ...comittedStmnt }); //Committed stmnt
              }
            });
        });
    });
  //..Add blank page with header and footer
  let tempBlankGM = {
    //GMHeader
    margin: [0, 10, 0, 0],
    layout: "noBorders",
    pageBreak: "before",
    table: {
      widths: ["*"],
      heights: [30],
      style: "summarySection",
      alignment: "center",
      body: [[]],
    },
  };
  content.push({ ...tempBlankGM });

  temp.content = [...content];
  const pdfDocGenerator = pdfMake.createPdf(temp);
  pdfDocGenerator.getBuffer(async (buffer) => {
    const pdfDoc = await PDFDocument.load(buffer);
    //pdfDoc.registerFontkit(fontkit);
    const helveticaFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const pages = pdfDoc.getPages();
    const lastPage = pdfDoc.getPage(pages.length - 1);
    const { width, height } = lastPage.getSize();
    const form = pdfDoc.getForm();
    lastPage.moveTo(60, 530);
    lastPage.drawText('What progress have you made on the focus statements above?', {
      //x: 5,
      //y: height / 2 + 300,
      size: 12,
      font: helveticaFont,
      maxWidth: 600
      //color: rgb(0.95, 0.1, 0.1),
      //rotate: degrees(-45),
    });
    const notesField = form.createTextField('summary.notes');
    notesField.addToPage(lastPage, { x: 60, y: 395, width: 600, height: 120, borderWidth: 0 });

    const textField = form.getTextField('summary.notes');
    textField.enableMultiline();
    //textField.enableSpellChecking();
    textField.setMaxLength(500);
    //textField.setText('This works fine');
    const da = textField.acroField.getDefaultAppearance() ?? '';
    const newDa = da + '\n' + setFontAndSize('Courier', 10).toString(); //setFontAndSize() method came to resuce
    textField.acroField.setDefaultAppearance(newDa);

    //..Question 2
    lastPage.moveTo(60, 360);
    lastPage.drawText(`What additional accomplishments/activities would you like to discuss not readily apparent above or in your feedback?`, {
      size: 12,
      font: helveticaFont,
      maxWidth: 600
    });
    const feedbackField = form.createTextField('summary.feedback');
    feedbackField.addToPage(lastPage, { x: 60, y: 201, width: 600, height: 120, borderWidth: 0 });

    const feedbackTextField = form.getTextField('summary.feedback');
    feedbackTextField.enableMultiline();
    //textField.enableSpellChecking();
    feedbackTextField.setMaxLength(500);
    //textField.setText('This works fine');
    const daFeedback = feedbackTextField.acroField.getDefaultAppearance() ?? '';
    const newDaFeedback = daFeedback + '\n' + setFontAndSize('Courier', 10).toString(); //setFontAndSize() method came to resuce
    feedbackTextField.acroField.setDefaultAppearance(newDaFeedback);

    // const notesField2 = form.createTextField('summary.notes2');
    // notesField2.addToPage(lastPage, { x: 60, y: 450, width: 600, height: 20, borderWidth: 0 });
    // const notesField3 = form.createTextField('summary.notes3');
    // notesField3.addToPage(lastPage, { x: 60, y: 430, width: 600, height: 20, borderWidth: 0 });
    const pdfBytes = await pdfDoc.save();
    const bytes = new Uint8Array(pdfBytes);
    const blob = new Blob([bytes], { type: "application/pdf" });
    const docUrl = URL.createObjectURL(blob);
    let alink = document.createElement('a');
    alink.href = docUrl;
    alink.download = fileName;
    alink.click();
  });

  //pdfMake.createPdf(temp).download(fileName);
  // open();
  //
};

export default focuspdfmakedownload;
